import styled from "styled-components";
import { Button, Type, Flex } from "discover.medical.react-component-library";

export const DrugInteractionsPolicyWrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-top: ${({ theme }) => theme.space.xl};
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 75%;
  }
`;

export const DrugInteractionsPolicyHeader = styled(Flex)`
  padding: ${({ theme }) => theme.space.lg} 0 ${({ theme }) => theme.space.md};
`;

export const DrugInteractionsPolicyTitle = styled(Type)`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: flex;
  }
`;

export const DrugInteractionsPolicyAcceptButton = styled(Button)`
  margin: ${({ theme }) => theme.space.xxl} 0;
`;
